import { Collapse } from '@components/Collapse';
import ColorPicker from '@components/ColorPicker';
import Title from '@components/Title';
import useTemplateFeature from '@hooks/useTemplateFeature';
import useTourEditing from '@hooks/useTourEditing';
import { $templateId } from '@stores/dataStores';
import { $editingUIColor } from '@stores/editingStores';
import { type EditConfigUI, TemplateId } from '@types';
import { useStore } from 'effector-react';
import { useEffect } from 'react';
import PanelBase from '../PanelBase';
import type { PanelBaseProps } from '../types';

// 新建作品无ui数据, 进入功能编辑时使用默认数据

function UIColorBase({
  defaultValue,
  onConfirm,
}: PanelBaseProps<EditConfigUI>) {
  const templateId = useStore($templateId);
  const defaultUI = useTemplateFeature('uiColor') ?? {};
  const { state, setState, isChanged } = useTourEditing(
    defaultValue,
    defaultUI
  );

  useEffect(() => {
    $editingUIColor.api.set(state);
    return () => {
      $editingUIColor.api.set(null);
    };
  }, [state]);

  const renderSetting = (key: keyof EditConfigUI, title: string) => {
    const defaultColor = defaultUI[key];
    if (!defaultColor) return null;
    return (
      <ColorPicker
        className="mb-20"
        colorString={state[key]}
        onChange={(colorString) =>
          setState((draft) => {
            draft[key] = colorString;
          })
        }
      >
        <ColorPicker.Header>
          <div>{title}</div>
          <ColorPicker.Reset defaultColor={defaultColor} />
        </ColorPicker.Header>
        <ColorPicker.Bar />
      </ColorPicker>
    );
  };

  return (
    <PanelBase
      isChanged={isChanged}
      onConfirm={() => onConfirm(state)}
      title={<Title>界面配色</Title>}
    >
      {[
        TemplateId.project,
        TemplateId.vip,
        TemplateId.legacy,
        TemplateId.realEstateA,
        TemplateId.realEstateB,
        TemplateId.simple,
      ].includes(templateId) ? (
        <Collapse title="整体界面配色">
          {renderSetting('fontColor', '字体/图标默认颜色')}
          {renderSetting('fontAvtiveColor', '字体/图标选中颜色')}
          {renderSetting('bgColor', '按钮默认颜色')}
          {renderSetting('btnActiveColor', '按钮选中颜色')}
          {renderSetting('panelBgColor', '背景颜色')}
        </Collapse>
      ) : (
        <Collapse title="场景选择栏配色">
          {renderSetting('fontColor', '字体/图标默认颜色')}
          {renderSetting('fontAvtiveColor', '字体/图标选中颜色')}
          {renderSetting('bgColor', '按钮默认颜色')}
          {renderSetting('btnActiveColor', '按钮选中颜色')}
        </Collapse>
      )}
    </PanelBase>
  );
}

export default UIColorBase;
